"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toaster = void 0;

var _stylitas = require("@creditas/stylitas");

const toaster = ({
  theme,
  variant
}) => (0, _stylitas.css)`
  align-items: center;
  background: ${theme.bColorneutral01};
  border: solid 1px ${theme.bColorneutral03};
  border-left: 8px solid ${theme[`bColor${variant.toLowerCase()}`]};
  border-radius: 4px;
  display: flex;
  flex-wrap: nowrap;
  min-height: 96px;
  overflow: hidden;
  padding: 12px 0;
  position: relative;
  max-width: 470px;
  width: 100vw;

  > div {
    flex-shrink: 1;
  }
`;

exports.toaster = toaster;